module.exports = __webpack_public_path__ + "static/media/dw-logo.8f88c395.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dw-logo.png
// module id = 499
// module chunks = 0